export default __webpack_public_path__ + "images/graphics/tires-caravan.svg";